<template>
  <section id="template-view-area">
    <sc-card v-if="templateData">
      <template slot="body">
        <billing-template-summary
          :logisticProviderId="templateData.logisticProviderId"
          :templateName="templateData.name"
          :templateRowNumber="templateData.headerRow"
        />

        <section id="fields-grid" :class="gridSizeClass">
          <div class="column-header">Nome do dado</div>
          <div class="column-header">Coluna</div>
          <div v-if="containsPreview()" class="column-header">Nome do dado na fatura</div>

          <template v-for="[key, value] in columnsEnum" v-if="templateValues[key]">
            <div class="column-name">{{ value.label }}</div>
            <div class="column-value">{{ templateValues[key] }}</div>
            <div v-if="templatePreview[key]" class="column-name">{{ templatePreview[key] }}</div>
          </template>
        </section>

      </template>
    </sc-card>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScCard } from '@intelipost-js/secure-components';
import BillingTemplateSummary from './BillingTemplateSummary.vue';
import BillingTemplateColumnsEnum from '../../../enum/billing-tamplate-columns.enum';

const { mapActions } = createNamespacedHelpers('recon/billing');

export default {
  name: 'BillingTemplateViewMode',
  components: { ScCard, BillingTemplateSummary },
  props: { templateId: { type: String, required: true } },
  data() {
    return {
      templateData: null,
      templateValues: null,
      templatePreview: null,
    };
  },
  methods: {
    ...mapActions(['loadSingleTemplate']),
    containsPreview() {
      return this.templatePreview && Object.values(this.templatePreview).every(p => p !== null);
    },
  },
  computed: {
    columnsEnum() {
      return Object.entries(BillingTemplateColumnsEnum) || {};
    },
    gridSizeClass() {
      return this.containsPreview() ? 'three-columns' : 'two-columns';
    },
  },
  created() {
    this.loadSingleTemplate(this.templateId).then((viewTemplate) => {
      // fill form state vars with the columnsMapping values
      const mappingTransformer = mappingProp =>
        viewTemplate.columnsMapping.reduce((acc, obj) => {
          acc[obj.columnName] = obj[mappingProp];
          return acc;
        }, {});

      this.templateData = viewTemplate;
      this.templateValues = mappingTransformer('columnId');
      this.templatePreview = mappingTransformer('columnPreview');
    });
  },
};
</script>

<style lang="scss">
#template-view-area {
  .sc-card {
    border-radius: 8px;
  }

  #fields-grid {
    display: grid;
    justify-content: start;
    column-gap: 16px;
    row-gap: 8px;

    &.two-columns {
      grid-template-columns: auto 70px;
    }

    &.three-columns {
      grid-template-columns: auto 70px auto;
    }

    .column-header {
      color: #39554A;
    }

    .column-name {
      border-radius: 10px;
      color: #010906;
      background-color: #F3F4F4;
      border: 1px solid #EBEBEB;
      padding: 8px 40px 8px 16px;
    }

    .column-value {
      border-radius: 10px;
      color: #010906;
      padding: 8px 40px 8px 16px;
      border: 1px solid #EBEBEB;
    }
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-recon/features/billing/pages/templates/components/BillingTemplateViewMode.vue